import styled from '@emotion/styled';
import Select from 'react-select';
import { mqMin, theme } from '@lucid/theme';

const CaseStudySelect = styled(Select)({
  '& .csh-filter__control': {
    border: 0,
    borderRadius: 0,
    borderBottom: `1px solid ${theme.colors.coolGrey[20]}`,
    '&:hover, &--is-focused': {
      borderColor: theme.colors.coolGrey[20],
      boxShadow: 'none'
    }
  },
  '& .csh-filter__indicator-separator': {
    width: 0
  },
  '& .csh-filter__menu': {
    margin: 0,
    borderRadius: 0,
    background: theme.colors.coolGrey[80],
    zIndex: theme.zIndices[3]
  },
  '& .csh-filter__menu-list': {
    padding: theme.space[1],
    display: 'flex',
    flexFlow: 'row wrap'
  },
  '& .csh-filter__option': {
    cursor: 'pointer',
    color: theme.colors.white,
    flex: '0 1 100%',
    fontSize: theme.fontSizes[2],
    [mqMin.mobile]: {
      flex: '0 1 50%'
    },
    '&:hover, &:active, &:focus, &--is-focused, &--is-selected': {
      textDecoration: 'underline',
      background: 'transparent'
    }
  }
});

export default CaseStudySelect;
